import { Text, View } from "react-native";
import ProfilePostListItem from "./item";
import styles from "./styles";
import { RootState } from "../../../redux/store";

export default function ProfilePostList({
  posts,
}: {
  posts: RootState["post"]["currentUserPosts"];
}) {
  return (
    <View style={styles.container}>
      {posts?.length ? (
        <View style={styles.grid}>
          {posts.map((item) => (
            <ProfilePostListItem item={item} key={item.id} />
          ))}
        </View>
      ) : (
        <Text style={styles.emptyText}>暂无发布视频</Text>
      )}
    </View>
  );
}
